import React from 'react';
import { Routes, Route } from 'react-router-dom';
import UserRoleMappingList from './UserRoleMappingList';
import UserRoleMappingForm from './UserRoleMappingForm';
import ProtectedRoute from '../../../routes/ProtectedRoutes';
import UserPermissionList from '../user/UserPermissionList';

const UserRoleMappingIndex: React.FC = () => {
  return (
    <Routes>
      <Route path="" element={<UserRoleMappingList />} />
      <Route path="create" element={<UserRoleMappingForm />} />
      <Route path=":id/edit" element={<UserRoleMappingForm />} />
      <Route
        path=":id/view"
        element={<ProtectedRoute element={<UserRoleMappingForm viewMode={true} />} />}
      />
      
    </Routes>
  );
};

export default UserRoleMappingIndex;